import Vue from 'vue'
import BootstrapVueArsenic from '../../src'

Vue.use(BootstrapVueArsenic, {})
